const CxMinimize = ():JSX.Element=>{    
    return(
        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 1H1" stroke="#999B9F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
}
export default CxMinimize

